import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import Screen from "@bd-utils/screen";

/**
 * @typedef {Window & { screenCalculationFunc?: Function }} ExtendedWindow
 */

export default class BD_Component {
    constructor() {
        this._data = {};

        this._events = null;
        this._registeredEvents = [];

        /* Change this to true if your block requires server-side data */
        this._serverSide = false;

        //add current component to component list
        bdjs.registerComponent(this);
    }

    // NOTE: this is just a placeholder hooks that can be used later in the code
    beforeInit() {}
    afterInit() {}
    beforeDestroy() {}
    afterDestroy() {}

    _setData(id, data) {
        this.roomId = id;
        this._data = Object.assign({}, data);
    }

    init() {
        typeof /** @type {ExtendedWindow} */ (window).screenCalculationFunc === "function" &&
        (/** @type {ExtendedWindow} */ (window).screenCalculationFunc = () => Screen.calculateCoverSize());

        if (this.beforeInit) this.beforeInit();
        this.registerEvents();
        if (this.afterInit) this.afterInit();
    }

    destroy() {
        if (this.beforeDestroy) this.beforeDestroy();
        this.deregisterEvents();
        if (this.afterDestroy) this.afterDestroy();
    }

    registerEvents() {
        if (!Array.isArray(this._events)) return false;

        const self = this;
        this._events.map((item) => {
            /**
             * NOTE: don't use arrow function, because we want to pointing
             * _this_ to the jQuery element itself
             * @param {Event} e
             */
            const handler = function (e) {
                item.handler.call(self, e, $(this), item.params);
            };

            this._registeredEvents.push(handler);

            if (document == item.selector) {
                $(document).on(item.event, handler);
            } else {
                const selector = /** @type {string} */ (item.selector);
                $(document).on(item.event, selector, handler);
            }
        });
    }

    deregisterEvents() {
        if (!Array.isArray(this._events)) return false;
        this._events.map((item, i) => {
            const handler = this._registeredEvents[i];

            // if (document == item.selector) { $(document).off(item.event, handler); return; }
            // $(document).off(item.event, item.selector, handler);

            if (document == item.selector) {
                $(document).off(item.event, handler);
            } else {
                const selector = /** @type {string} */ (item.selector);
                $(document).off(item.event, selector, handler);
            }
        });

        this._registeredEvents = [];
    }
}
